{
  "asAt": "23 Sept 2026",
  "asAtIso": "2026-09-22T23:22:28.448Z",
  "runAt": "2026-09-22T23:22:28.448Z",
  "warnings": [
    "ING Mortgage Simplifier 70-80%: CDR_ONLY — Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
    "Macquarie Bank Basic Home Loan 70-80%: CDR_ONLY — Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
    "IMB Budget Home Loan <=70%: CDR_ONLY — Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
    "IMB Budget Home Loan 70-80%: CDR_ONLY — Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
    "IMB Budget Home Loan 80-90%: CDR_ONLY — Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
    "IMB Budget Home Loan 90-95%: CDR_ONLY — Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
    "IMB Budget Home Loan IO <=70%: CDR_ONLY — Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
    "IMB Budget Home Loan IO 70-80%: CDR_ONLY — Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
    "IMB Budget Home Loan investment <=80%: CDR_ONLY — Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
    "IMB Budget Home Loan investment 80-90%: CDR_ONLY — Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
    "IMB Budget Home Loan investment IO <=80%: CDR_ONLY — Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page."
  ],
  "products": [
    {
      "id": "ing-simplifier-oo-pi-80",
      "lender": "ING",
      "product": "Mortgage Simplifier 70-80%",
      "rate": 6.09,
      "comparisonRate": 6.12,
      "occupancy": "owner",
      "repayment": "pi",
      "maxLvr": 80,
      "minLvr": 70,
      "minLoan": 150000,
      "cashback": 0,
      "ongoingFee": 0,
      "ratesUrl": "https://www.ing.com.au/rates-and-fees/home-loan-rates.html",
      "finePrint": "ING Mortgage Simplifier owner-occupier P&I at 70.01–80% LVR, min $150,000. Do not quote the 5.99% band on an 80% file. Not Orange Advantage (package/offset).",
      "status": "verified",
      "verifiedAt": "2026-09-22T23:22:28.448Z",
      "sourceKind": "cdr",
      "citations": [
        {
          "kind": "lender-page",
          "url": "https://www.ing.com.au/rates-and-fees/home-loan-rates.html",
          "ok": false,
          "note": "Scrapling fallback had no row that matched this LVR band"
        },
        {
          "kind": "cdr",
          "url": "https://www.ing.com.au/rates-and-fees/home-loan-rates.html",
          "ok": true,
          "note": "CDR matched 6.09% at ≤80% LVR"
        }
      ],
      "needsReview": true,
      "reviewReason": "Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
      "reviewStatus": "CDR_ONLY",
      "fetchMode": "http",
      "pageCheckedAt": "2026-09-22T23:22:28.448Z",
      "cdrCheckedAt": "2026-09-22T23:22:28.448Z",
      "previousRate": 6.04,
      "firstSeen": "2026-08-19T11:00:00.000Z",
      "lastSeen": "2026-09-22T23:22:28.448Z",
      "confidence": 0.1,
      "evidenceHash": ""
    },
    {
      "id": "macquarie-basic-oo-pi-80",
      "lender": "Macquarie Bank",
      "product": "Basic Home Loan 70-80%",
      "rate": 6.09,
      "comparisonRate": 6.11,
      "occupancy": "owner",
      "repayment": "pi",
      "maxLvr": 80,
      "minLvr": 70,
      "cashback": 0,
      "ongoingFee": 0,
      "ratesUrl": "https://www.macquarie.com.au/home-loans/home-loan-rates.html",
      "finePrint": "Macquarie Basic owner-occupier P&I at 70–80% LVR. Do not quote the 6.04% ≤70% band on an 80% file. Not the Offset product (higher comparison rate).",
      "status": "verified",
      "verifiedAt": "2026-09-22T23:22:28.448Z",
      "sourceKind": "cdr",
      "citations": [
        {
          "kind": "lender-page",
          "url": "https://www.macquarie.com.au/home-loans/home-loan-rates.html",
          "ok": false,
          "note": "Scrapling fallback had no row that matched this LVR band"
        },
        {
          "kind": "cdr",
          "url": "https://www.macquarie.com.au/home-loans/home-loan-rates.html",
          "ok": true,
          "note": "CDR matched 6.09% at ≤80% LVR"
        }
      ],
      "needsReview": true,
      "reviewReason": "Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
      "reviewStatus": "CDR_ONLY",
      "fetchMode": "http",
      "pageCheckedAt": "2026-09-22T23:22:28.448Z",
      "cdrCheckedAt": "2026-09-22T23:22:28.448Z",
      "previousRate": 6.09,
      "firstSeen": "2026-08-19T11:00:00.000Z",
      "lastSeen": "2026-09-22T23:22:28.448Z",
      "confidence": 0.1,
      "evidenceHash": ""
    },
    {
      "id": "imb-budget-oo-pi-70",
      "lender": "IMB",
      "product": "Budget Home Loan <=70%",
      "rate": 5.99,
      "comparisonRate": 6.02,
      "occupancy": "owner",
      "repayment": "pi",
      "maxLvr": 70,
      "cashback": 3000,
      "ongoingFee": 0,
      "ratesUrl": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
      "finePrint": "IMB Budget owner-occupier P&I at ≤70% LVR. There is no 5.89% Budget print. Cashback is IMB’s advertised offer — confirm the current amount.",
      "status": "verified",
      "verifiedAt": "2026-09-22T23:22:28.448Z",
      "sourceKind": "cdr",
      "citations": [
        {
          "kind": "lender-page",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": false,
          "note": "Scrapling fallback had no row that matched this LVR band"
        },
        {
          "kind": "cdr",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": true,
          "note": "CDR matched 5.99% at ≤70% LVR"
        }
      ],
      "needsReview": true,
      "reviewReason": "Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
      "reviewStatus": "CDR_ONLY",
      "fetchMode": "scrapling",
      "pageCheckedAt": "2026-09-22T23:22:28.448Z",
      "cdrCheckedAt": "2026-09-22T23:22:28.448Z",
      "previousRate": 5.99,
      "firstSeen": "2026-08-14T00:00:00.000+10:00",
      "lastSeen": "2026-09-22T23:22:28.448Z",
      "evidenceHash": "d8e4ae1372553ae82f24602c07675cc02e6bd9cab045696f1bc3d488113a2341",
      "confidence": 0.4
    },
    {
      "id": "imb-budget-oo-pi-80",
      "lender": "IMB",
      "product": "Budget Home Loan 70-80%",
      "rate": 6.04,
      "comparisonRate": 6.07,
      "occupancy": "owner",
      "repayment": "pi",
      "maxLvr": 80,
      "minLvr": 70,
      "cashback": 3000,
      "ongoingFee": 0,
      "ratesUrl": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
      "finePrint": "IMB Budget owner-occupier P&I at 70–80% LVR. Do not quote the ≤70% rate on this band.",
      "status": "verified",
      "verifiedAt": "2026-09-22T23:22:28.448Z",
      "sourceKind": "cdr",
      "citations": [
        {
          "kind": "lender-page",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": false,
          "note": "Scrapling fallback had no row that matched this LVR band"
        },
        {
          "kind": "cdr",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": true,
          "note": "CDR matched 6.04% at ≤80% LVR"
        }
      ],
      "needsReview": true,
      "reviewReason": "Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
      "reviewStatus": "CDR_ONLY",
      "fetchMode": "scrapling",
      "pageCheckedAt": "2026-09-22T23:22:28.448Z",
      "cdrCheckedAt": "2026-09-22T23:22:28.448Z",
      "previousRate": 6.04,
      "firstSeen": "2026-08-14T00:00:00.000+10:00",
      "lastSeen": "2026-09-22T23:22:28.448Z",
      "evidenceHash": "d8e4ae1372553ae82f24602c07675cc02e6bd9cab045696f1bc3d488113a2341",
      "confidence": 0.4
    },
    {
      "id": "imb-budget-oo-pi-90",
      "lender": "IMB",
      "product": "Budget Home Loan 80-90%",
      "rate": 6.29,
      "comparisonRate": 6.35,
      "occupancy": "owner",
      "repayment": "pi",
      "maxLvr": 90,
      "minLvr": 80,
      "cashback": 0,
      "ongoingFee": 0,
      "ratesUrl": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
      "finePrint": "IMB Budget owner-occupier P&I at 80–90% LVR.",
      "status": "verified",
      "verifiedAt": "2026-09-22T23:22:28.448Z",
      "sourceKind": "cdr",
      "citations": [
        {
          "kind": "lender-page",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": false,
          "note": "Scrapling fallback had no row that matched this LVR band"
        },
        {
          "kind": "cdr",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": true,
          "note": "CDR matched 6.29% at ≤90% LVR"
        }
      ],
      "needsReview": true,
      "reviewReason": "Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
      "reviewStatus": "CDR_ONLY",
      "fetchMode": "scrapling",
      "pageCheckedAt": "2026-09-22T23:22:28.448Z",
      "cdrCheckedAt": "2026-09-22T23:22:28.448Z",
      "previousRate": 6.29,
      "firstSeen": "2026-08-14T00:00:00.000+10:00",
      "lastSeen": "2026-09-22T23:22:28.448Z",
      "evidenceHash": "d8e4ae1372553ae82f24602c07675cc02e6bd9cab045696f1bc3d488113a2341",
      "confidence": 0.4
    },
    {
      "id": "imb-budget-oo-pi-95",
      "lender": "IMB",
      "product": "Budget Home Loan 90-95%",
      "rate": 6.64,
      "comparisonRate": 6.7,
      "occupancy": "owner",
      "repayment": "pi",
      "maxLvr": 95,
      "minLvr": 90,
      "cashback": 0,
      "ongoingFee": 0,
      "ratesUrl": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
      "finePrint": "IMB Budget owner-occupier P&I at 90–95% LVR.",
      "status": "verified",
      "verifiedAt": "2026-09-22T23:22:28.448Z",
      "sourceKind": "cdr",
      "citations": [
        {
          "kind": "lender-page",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": false,
          "note": "Scrapling fallback had no row that matched this LVR band"
        },
        {
          "kind": "cdr",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": true,
          "note": "CDR matched 6.64% at ≤95% LVR"
        }
      ],
      "needsReview": true,
      "reviewReason": "Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
      "reviewStatus": "CDR_ONLY",
      "fetchMode": "scrapling",
      "pageCheckedAt": "2026-09-22T23:22:28.448Z",
      "cdrCheckedAt": "2026-09-22T23:22:28.448Z",
      "previousRate": 6.64,
      "firstSeen": "2026-08-14T00:00:00.000+10:00",
      "lastSeen": "2026-09-22T23:22:28.448Z",
      "evidenceHash": "d8e4ae1372553ae82f24602c07675cc02e6bd9cab045696f1bc3d488113a2341",
      "confidence": 0.4
    },
    {
      "id": "imb-budget-oo-io-70",
      "lender": "IMB",
      "product": "Budget Home Loan IO <=70%",
      "rate": 6.29,
      "comparisonRate": 6.18,
      "occupancy": "owner",
      "repayment": "io",
      "maxLvr": 70,
      "cashback": 0,
      "ongoingFee": 0,
      "ratesUrl": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
      "finePrint": "IMB Budget owner-occupier interest-only at ≤70% LVR.",
      "status": "verified",
      "verifiedAt": "2026-09-22T23:22:28.448Z",
      "sourceKind": "cdr",
      "citations": [
        {
          "kind": "lender-page",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": false,
          "note": "Scrapling fallback had no row that matched this LVR band"
        },
        {
          "kind": "cdr",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": true,
          "note": "CDR matched 6.29% at ≤70% LVR"
        }
      ],
      "needsReview": true,
      "reviewReason": "Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
      "reviewStatus": "CDR_ONLY",
      "fetchMode": "scrapling",
      "pageCheckedAt": "2026-09-22T23:22:28.448Z",
      "cdrCheckedAt": "2026-09-22T23:22:28.448Z",
      "previousRate": 6.29,
      "firstSeen": "2026-08-14T00:00:00.000+10:00",
      "lastSeen": "2026-09-22T23:22:28.448Z",
      "evidenceHash": "d8e4ae1372553ae82f24602c07675cc02e6bd9cab045696f1bc3d488113a2341",
      "confidence": 0.4
    },
    {
      "id": "imb-budget-oo-io-80",
      "lender": "IMB",
      "product": "Budget Home Loan IO 70-80%",
      "rate": 6.34,
      "comparisonRate": 6.23,
      "occupancy": "owner",
      "repayment": "io",
      "maxLvr": 80,
      "minLvr": 70,
      "cashback": 0,
      "ongoingFee": 0,
      "ratesUrl": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
      "finePrint": "IMB Budget owner-occupier interest-only at 70–80% LVR.",
      "status": "verified",
      "verifiedAt": "2026-09-22T23:22:28.448Z",
      "sourceKind": "cdr",
      "citations": [
        {
          "kind": "lender-page",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": false,
          "note": "Scrapling fallback had no row that matched this LVR band"
        },
        {
          "kind": "cdr",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": true,
          "note": "CDR matched 6.34% at ≤80% LVR"
        }
      ],
      "needsReview": true,
      "reviewReason": "Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
      "reviewStatus": "CDR_ONLY",
      "fetchMode": "scrapling",
      "pageCheckedAt": "2026-09-22T23:22:28.448Z",
      "cdrCheckedAt": "2026-09-22T23:22:28.448Z",
      "previousRate": 6.34,
      "firstSeen": "2026-08-14T00:00:00.000+10:00",
      "lastSeen": "2026-09-22T23:22:28.448Z",
      "evidenceHash": "d8e4ae1372553ae82f24602c07675cc02e6bd9cab045696f1bc3d488113a2341",
      "confidence": 0.4
    },
    {
      "id": "imb-budget-inv-pi-80",
      "lender": "IMB",
      "product": "Budget Home Loan investment <=80%",
      "rate": 6.24,
      "comparisonRate": 6.3,
      "occupancy": "investment",
      "repayment": "pi",
      "maxLvr": 80,
      "cashback": 3000,
      "ongoingFee": 0,
      "ratesUrl": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
      "finePrint": "IMB Budget investment P&I at ≤80% LVR.",
      "status": "verified",
      "verifiedAt": "2026-09-22T23:22:28.448Z",
      "sourceKind": "cdr",
      "citations": [
        {
          "kind": "lender-page",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": false,
          "note": "Scrapling fallback had no row that matched this LVR band"
        },
        {
          "kind": "cdr",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": true,
          "note": "CDR matched 6.24% at ≤80% LVR"
        }
      ],
      "needsReview": true,
      "reviewReason": "Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
      "reviewStatus": "CDR_ONLY",
      "fetchMode": "scrapling",
      "pageCheckedAt": "2026-09-22T23:22:28.448Z",
      "cdrCheckedAt": "2026-09-22T23:22:28.448Z",
      "previousRate": 6.24,
      "firstSeen": "2026-08-14T00:00:00.000+10:00",
      "lastSeen": "2026-09-22T23:22:28.448Z",
      "evidenceHash": "d8e4ae1372553ae82f24602c07675cc02e6bd9cab045696f1bc3d488113a2341",
      "confidence": 0.4
    },
    {
      "id": "imb-budget-inv-pi-90",
      "lender": "IMB",
      "product": "Budget Home Loan investment 80-90%",
      "rate": 6.34,
      "comparisonRate": 6.4,
      "occupancy": "investment",
      "repayment": "pi",
      "maxLvr": 90,
      "minLvr": 80,
      "cashback": 0,
      "ongoingFee": 0,
      "ratesUrl": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
      "finePrint": "IMB Budget investment P&I at 80–90% LVR.",
      "status": "verified",
      "verifiedAt": "2026-09-22T23:22:28.448Z",
      "sourceKind": "cdr",
      "citations": [
        {
          "kind": "lender-page",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": false,
          "note": "Scrapling fallback had no row that matched this LVR band"
        },
        {
          "kind": "cdr",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": true,
          "note": "CDR matched 6.34% at ≤90% LVR"
        }
      ],
      "needsReview": true,
      "reviewReason": "Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
      "reviewStatus": "CDR_ONLY",
      "fetchMode": "scrapling",
      "pageCheckedAt": "2026-09-22T23:22:28.448Z",
      "cdrCheckedAt": "2026-09-22T23:22:28.448Z",
      "previousRate": 6.34,
      "firstSeen": "2026-08-14T00:00:00.000+10:00",
      "lastSeen": "2026-09-22T23:22:28.448Z",
      "evidenceHash": "d8e4ae1372553ae82f24602c07675cc02e6bd9cab045696f1bc3d488113a2341",
      "confidence": 0.4
    },
    {
      "id": "imb-budget-inv-io-80",
      "lender": "IMB",
      "product": "Budget Home Loan investment IO <=80%",
      "rate": 6.54,
      "comparisonRate": 6.44,
      "occupancy": "investment",
      "repayment": "io",
      "maxLvr": 80,
      "cashback": 0,
      "ongoingFee": 0,
      "ratesUrl": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
      "finePrint": "IMB Budget investment interest-only at ≤80% LVR.",
      "status": "verified",
      "verifiedAt": "2026-09-22T23:22:28.448Z",
      "sourceKind": "cdr",
      "citations": [
        {
          "kind": "lender-page",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": false,
          "note": "Scrapling fallback had no row that matched this LVR band"
        },
        {
          "kind": "cdr",
          "url": "https://www.imb.com.au/home-loans/living-in/budget-home-loan",
          "ok": true,
          "note": "CDR matched 6.54% at ≤80% LVR"
        }
      ],
      "needsReview": true,
      "reviewReason": "Lender page did not yield a number; CDR matched the last verified LVR band within 0.08%. Confirm on the lender page.",
      "reviewStatus": "CDR_ONLY",
      "fetchMode": "scrapling",
      "pageCheckedAt": "2026-09-22T23:22:28.448Z",
      "cdrCheckedAt": "2026-09-22T23:22:28.448Z",
      "previousRate": 6.54,
      "firstSeen": "2026-08-14T00:00:00.000+10:00",
      "lastSeen": "2026-09-22T23:22:28.448Z",
      "evidenceHash": "d8e4ae1372553ae82f24602c07675cc02e6bd9cab045696f1bc3d488113a2341",
      "confidence": 0.4
    }
  ]
}
